export const tryNoop = (f) => {
  try {
    return f();
  } catch {
    return null;
  }
};
